import { t } from '@lingui/core/macro';

import weekContextless from './weekContextless';

export default class Week extends weekContextless {
  // e.g. 'Sundays'
  static upperEnglishPluralLongName(dayNumber: number): string {
    const pluralDaysOfWeek = [
      t`Sundays`,
      t`Mondays`,
      t`Tuesdays`,
      t`Wednesdays`,
      t`Thursdays`,
      t`Fridays`,
      t`Saturdays`,
    ];

    const daysOrder = this.getDaysOrderByFirstDayOfWeek();
    return pluralDaysOfWeek[daysOrder[dayNumber]];
  }
}
